import React from "react";
import PropTypes from 'prop-types';
import { DropDown, useFormValidation } from "../../index";

export const DropDownWithValidation = ({
    customValidation,
    errorMsg,
    hintMsg,
    name,
    multiselect,
    onBlur = () => { },
    onChange = () => { },
    pattern,
    required = false,
    ...props
}) => {


    const validationRules = {
        [name]: {
            required: {
                value: required,
                message: errorMsg
            },
            pattern: {
                value: pattern,
                message: errorMsg
            },
            custom: {
                isValid: customValidation,
                message: errorMsg
            }
        }
    };

    const { handleInput, formErrors } = useFormValidation({ validations: validationRules });

    const handleChange = (event, changedItem) => {
        const value = event.target.value;
        handleInput(event);

        if (onChange) {
            if (multiselect) {
                onChange(event, value, changedItem, formErrors[name]?.value);
            } else {
                onChange(event, value, formErrors[name]?.value);
            }
        }
    }

    const handleBlur = (event) => {
        const value = event.target.value;
        handleInput(event);

        if (onBlur) {
            onBlur(event, value, formErrors[name]?.value);
        }
    }

    return (
        <DropDown
            {...props}
            error={formErrors[name]?.value}
            hintMsg={hintMsg ? hintMsg : formErrors[name]?.message}
            name={name}
            multiselect={multiselect}
            onBlur={handleBlur}
            onChange={handleChange}
            required={required}
        />
    )
}

DropDownWithValidation.propTypes = {
    customValidation: PropTypes.func,
    errorMsg: PropTypes.string,
    hintMsg: PropTypes.string,
    name: PropTypes.string,
    multiselect: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    pattern: PropTypes.string,
    required: PropTypes.bool,
}